var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-contract"},[_c('div',{staticClass:"content"},[_c('iframe',{ref:"contractIframe",staticClass:"frame",attrs:{"src":_vm.authUrl,"scrolling":"true","frameborder":"0"},on:{"error":_vm.handleIframeError}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }